<script>
  import { createWidget } from "@typeform/embed";
  import "@typeform/embed/build/css/widget.css";
  import { onMount } from "svelte";
  import Bleed from "./Bleed.svelte";

  export let id;
  export let hideHeaders = false;
  export let hideFooter = false;
  export let lazy = false;
  export let enableSandbox = false;

  onMount(() => {
    createWidget(id, {
      container: document.querySelector(`#typeform-container`),
      hideHeaders,
      hideFooter,
      lazy,
      enableSandbox
    });
  });
</script>

<Bleed fullWidth class="embedded-content">
  <div id="typeform-container" class="md:h-[50vh] sm:h-[75vh]" data-chromatic="ignore" />
</Bleed>
